var _circle, _line, _line2, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssigneeToAntherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#EEF2FF",
    stroke: "#C7D2FE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 5,
    x2: 4,
    y2: 9,
    stroke: "#4F46E5",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 7,
    x2: 6,
    y2: 7,
    stroke: "#4F46E5",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 6,
    r: 1.8,
    fill: "#4F46E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11c0-1.6 2-2.5 2.7-2.5s2.7.9 2.7 2.5",
    fill: "none",
    stroke: "#4F46E5",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigneeToAntherIcon);
export default __webpack_public_path__ + "static/media/assignee-to-anther-icon.976294d64adbef1c4732d73778076533.svg";
export { ForwardRef as ReactComponent };